import { render, staticRenderFns } from "./ImportWizard.vue?vue&type=template&id=0bf865bc&scoped=true&"
import script from "./ImportWizard.vue?vue&type=script&lang=js&"
export * from "./ImportWizard.vue?vue&type=script&lang=js&"
import style0 from "./ImportWizard.vue?vue&type=style&index=0&id=0bf865bc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bf865bc",
  null
  
)

export default component.exports